import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonMedicineModel } from 'src/app/model/common/medicine';
import { CommonMedicineViewModel } from 'src/app/model/common/medicine.view';
import esTranslation from 'src/assets/translations/es.json';
import { CommonMedicineService } from './common.medicine.service';

@Component({
  selector: 'ms-common-medicine',
  templateUrl: './common.medicine.component.html',
})
export class CommonMedicineComponent extends BaseComponent {
  override readonly screen = {
    ...esTranslation,
    id: 'khuyana.common.medicine',
    title: 'Recetario con código ATC',
  };

  protected setScreen = true;
  atc = '';
  medicines: CommonMedicineViewModel[] = [];
  showAddNew = false;
  medicine: CommonMedicineModel = {};

  constructor(
    protected service: CommonMedicineService,
    protected activatedRoute: ActivatedRoute
  ) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service
        .getLoad()
        .subscribe((medicines) => (this.medicines = medicines))
    );
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.atc = paramMap.get('id') || 'NOT_VALID';
      this.service.setScreenInformation({
        id: this.screen.id,
        title: `${this.screen.title}: ${this.atc.toUpperCase()}`,
      });
      this.service.readList(this.atc).subscribe();
    });
  };

  showModal = () => {
    this.medicine = {
      atc: this.atc,
    };
    this.showAddNew = true;
  };

  addNew = () => {
    this.saving = true;
    this.service
      .createMedicine(this.medicine)
      .pipe(
        tap(() => {
          this.medicine = {};
          this.showAddNew = false;
          this.saving = false;
        })
      )
      .subscribe();
  };
}
